module.exports = __webpack_public_path__ + "static/media/img1.1541b74e.jpg";